import React, { Component } from "react";
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from "routes";
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { dateSplit } from '/utils/common';

const styles = theme => ({
    shadow: {
        position: 'relative',
        '&::before': {
            content: '""',
            width: '100%',
            height: 90,
            position: 'absolute',
            bottom: 0,
            left: 0,
            background: 'linear-gradient(0deg,rgba(0,0,0,.9) 20%,rgba(0,0,0,.8) 40%,rgba(0,0,0,.7) 49%,transparent)',
            [theme.breakpoints.up('md')]: {
                borderRadius: 5
            }
        }
    },
    imgRoot: {
        [theme.breakpoints.up('md')]: {
            borderRadius: 5
        }
    }
})

export function EventTeaserParts(props){
    const { title, startDate, endDate, place, customStyleProps } = props;
    return(
        <div style={{ position: 'absolute', bottom: 0, left: 0, padding: '16px 16px 10px', width: '100%', ...customStyleProps }} >
            <Typography component="h2" style={{ 
                color: '#fff',
                fontSize: 20,
                fontWeight: 500,
                lineHeight: 1,
                letterSpacing: '.02em',
            }} >
                {title}
            </Typography>
            <Typography component="div" style={{ 
                 color: '#fff',
                 fontSize: 13,
                 lineHeight: 1,
                 letterSpacing: '.02em',
                 paddingBottom: 3,
                 marginTop: 5,
            }} >
                <div style={{ marginBottom: 3 }}>
                    <Icon style={{ fontSize: 12, marginRight: 2 }}>calendar_today</Icon>
                    <span style={{ textTransform: 'capitalize', display: 'inline-block' }}>{`${dateSplit(startDate)} ~ ${dateSplit(endDate)}`}</span>   
                </div>
                <div>
                    <Icon style={{ fontSize: 12, marginRight: 2 }}>location_on</Icon>
                    <span style={{ textTransform: 'capitalize', display: 'inline-block' }}>{place}</span> 
                </div>
               </Typography>
           
        </div>    
    )
}
export function EventTeaser(props){
    const { classes, img, place, title, startDate, endDate, routeName, params } = props;
    return(
    <div className={classes.shadow} >
        <Link route={routeName} params={params}>
            <a className="anchor-link">
                <CardMedia
                    classes={{root: classes.imgRoot }}
                    style={{ cursor: 'pointer',  paddingTop: '56.25%', height: 90 }}
                    image={img}
                />
                <EventTeaserParts place={place} title={title} startDate={startDate} endDate={endDate} customStyleProps={{ cursor: 'pointer' }} />
        </a>
        </Link>
    </div>
    )
}
export function DesktopEventTeasers(props){
    const { classes, items } = props;
    return (
        items && items.length > 0 ? items.map(( item, index ) => {
           return( 
                <React.Fragment key={index}>
                        <Grid item xs={4} style={{padding: 8}}>
                            <EventTeaser 
                                classes={classes}
                                img={item.cover.thumb} 
                                startDate={item.start_date.date}
                                endDate={item.end_date.date}
                                title={item.title}
                                place={item.address}
                                routeName='eventDetail'
                                params={{id: item.slug}}
                            />
                        </Grid>
                </React.Fragment>
           )
         
        })  : null
        
    );
}
export function MobileEventTeasers(props){
    const { classes, items } = props;
    return (
        items && items.length > 0 ? items.map(( item, index ) => {
           return( 
                <React.Fragment key={index}>
                    <EventTeaser 
                        classes={classes}
                        img={item.cover.thumb} 
                        startDate={item.start_date.date}
                        endDate={item.end_date.date}
                        title={item.title}
                        place={item.address}
                        routeName='eventDetail'
                        params={{id: item.slug}}
                    />
                </React.Fragment>
           )
        })
        : null
    );
}

class EventTeasers extends Component {
    render() {
      const { classes, items, eventNextBtn, nextEventItems } = this.props;
      return (
        <>
            <Hidden only={['md', 'lg', 'xl']}>
                <MobileEventTeasers classes={classes} items={items} />
                <MobileEventTeasers classes={classes} items={nextEventItems} />
                {eventNextBtn}
            </Hidden>
            <Hidden smDown>
                <Grid container>
                    <DesktopEventTeasers classes={classes} items={items} />
                    <DesktopEventTeasers classes={classes} items={nextEventItems} />
               </Grid>
                {eventNextBtn}
            </Hidden>
        </>
      );
    }
  }
export default withStyles(styles)(EventTeasers);
